import { useEffect } from 'react'
import View from './view.js'
import { useDataValue, useDataChange } from 'Simple/Data.js'

export default function Logic(props) {
  let recipients = useDataValue({
    viewPath: props.viewPath,
    context: 'responsible_parties',
  })
  let recipient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'letter',
    path: 'recipient_id',
  })

  let change = useDataChange({
    context: 'letter',
    path: 'recipient_id',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!recipient_id && recipients.length === 1) {
      change(recipients[0].id)
    }
  }, [recipients.length, recipient_id])

  return <View {...props} />
}
